import type { FireflyRuntime } from "@squide/firefly";

export function handleUnauthorizedError(error: Error, runtime: FireflyRuntime) {
    const loginUrl = runtime.getEnvironmentVariable("loginUrl");
    const returnUrl = encodeURIComponent(window.location.href);

    // oxlint-disable-next-line typescript/restrict-template-expressions -- Squide 19.2.1's class d.ts types getEnvironmentVariable() as never; the registry holds a string
    window.location.href = `${loginUrl}?returnUrl=${returnUrl}`;
}
